import { useEffect, useState } from 'react';
import checkUserInfo from './check-user-info';
export function useUser() {
  var _useState = useState({
    isLoggedIn: true,
    isLoading: true
  }),
      user = _useState[0],
      setUser = _useState[1];

  useEffect(function () {
    var _ref = checkUserInfo() || {},
        _ref$id = _ref.id,
        userId = _ref$id === void 0 ? 0 : _ref$id;

    setUser({
      isLoggedIn: userId !== undefined && userId > 0,
      isLoading: false
    });
  }, []);
  return user;
}
export var UserStatus = {
  loading: 'loading',
  loggedIn: 'loggedIn',
  loggedOut: 'loggedOut'
};
export var useUserStatus = function useUserStatus() {
  var user = useUser();

  if (user.isLoading) {
    return UserStatus.loading;
  }

  if (user.isLoggedIn) {
    return UserStatus.loggedIn;
  }

  return UserStatus.loggedOut;
};
export default useUser;